import { render } from "./PurchasesListPage.vue?vue&type=template&id=9f82763a&ts=true"
import script from "./PurchasesListPage.vue?vue&type=script&lang=ts"
export * from "./PurchasesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__